import React from 'react'
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { ContainerBox, Table, ModalFooter } from "components";
import BaseComponent from '../BaseComponent';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import "./style.scss";
import {
    MODAL_ID, MODAL_SIZE, DATE_FORMAT, NO_DATE, TABLE_CODE, FORM_SETTING_EDITION,
    ACCESSOR_FORMSETTING_CLAUDE35, ACCESSOR_DATA_PROCESSING, DATA_PROCESSING_TYPE,
    ACCESSOR_DATA_PROCESSING_CONDITIONS, CONFIG_FILE_EDITION, DOCUMENT_DOWNLOAD_SETTING,
    CSV_DOWNLOAD_SETTING,
} from "../../core/utils/constants";
import moment from "moment";
import ResizablePanels from "resizable-panels-react";
import { ReactNotifications } from "core/logic";
import { Validate } from "core/utils";

@inject("modalStore", "commonStore")
@observer
class ScreenAISetting extends BaseComponent {
    constructor(props) {
        super(props);
        const { commonStore: { formSettingStore } } = this.props;
        this.state = {
            formSetting: JSON.parse(JSON.stringify(formSettingStore.formSettingDefault)),
            settingName: "",
            selectedIndexTab: 0,
            listCheckedItems: {},
            isCheckAll: false,
        }
        this.claude35InputRef = React.createRef();
    }

    isSubmited = false;
    isEditting = false;
    edition = FORM_SETTING_EDITION.CLAUDE;
    form = "";

    // Set value for controls after render DOM
    executeLogicAfterRender = async () => {
        const query = new URLSearchParams(window.location.search);
        this.edition = query.get('edition');
        this.form = query.get('form');
        this.props.commonStore.formSettingStore.clean();
        this.props.commonStore.formSettingStore.getAIModels();
        this.props.commonStore.formSettingStore.getAll(this.setEditionAndFormCallback);
        this.props.commonStore.postProcessingStore.clean();
        this.props.commonStore.postProcessingStore.getPostProcesses();
        this.props.commonStore.dataProcessingStore.clean();
        this.props.commonStore.dataProcessingStore.get();
    }

    setEditionAndFormCallback = () => {
        this.props.commonStore.formSettingStore.setFormEdition(this.edition);
        this.props.commonStore.formSettingStore.setClaude35ColumnSetting(this.props.commonStore.formSettingStore.claude35SettingDefault);
        this.setState({
            selectedIndexTab: 0,
        });
    }

    executeOnDidUpdate = () => {
        // Attach tooltip
        window.$('[data-toggle="tooltip"]').tooltip('destroy');
        window.$('[data-toggle="tooltip"]').tooltip({ container: '.screen-ai-setting', trigger: 'hover' });
    }

    onClaude35GeneralSettingChange = (event) => {
        const { t } = this.props;
        let name = event.target.name.toUpperCase();
        let value = event.target.value;

        if (event.target.type == "checkbox") {
            value = event.target.checked;
        }
        if (name == "PAGE_SPECIFICATION") {
            if (!this.validateClaude35TargetPages(value)) {
                this.setErrorMessage(name, t("form_setting.claude35.page_specification.error"));
            } else {
                this.setErrorMessage(name, "");
            }
        }

        this.props.commonStore.formSettingStore.changeClaude35GeneralSetting(name, value);
    }

    onClaude35SettingChange = (event) => {
        let name = event.target.name.toUpperCase();
        let value = event.target.value;

        if (event.target.type == "checkbox") {
            value = event.target.checked;
        }

        this.props.commonStore.formSettingStore.changeClaude35BasicSetting(name, value);
    }

    onChangeClaude35Setting = (id, force = false) => {
        if (this.isEditting && !force) {
            this.openChangeClaude35SettingWithoutSaveModal(id);
        }
        else {
            this.isEditting = false;
            if (id == "-1") {
                this.props.commonStore.formSettingStore.setClaude35ColumnSetting(this.props.commonStore.formSettingStore.claude35SettingDefault);
                this.props.commonStore.dataProcessingStore.setId(null);
            }
            else {
                let selectedFormSetting = this.props.commonStore.formSettingStore.claude35Settings?.settingBody?.settings.find(e => id == e.id);
                this.props.commonStore.formSettingStore.setClaude35ColumnSetting(selectedFormSetting);
                this.props.commonStore.dataProcessingStore.setId(selectedFormSetting.dataProcessingId);
            }
        }
    }

    openChangeClaude35SettingWithoutSaveModal = (id) => {
        const { modalStore, t } = this.props;
        modalStore.show({
            id: MODAL_ID.CONFIRM,
            isOpen: true,
            header: t("edit.change_page_confirm_title"),
            onCancel: () => this.closeModal(MODAL_ID.CONFIRM),
            children: (
                <div className="text-c">
                    <div key={"modal-body"} className="modal-body">
                        <span>{t("form_setting.change_setting_without_saving")}</span>
                    </div>
                    <ModalFooter
                        key={"modal-footer"}
                        saveButtonText={t("edit.change_page_yes")}
                        onConfirm={() => {
                            this.closeModal();
                            this.onChangeClaude35Setting(id, true);
                        }}
                        cancelButtonText={t("edit.change_page_no")}
                        onCancel={() => {
                            this.closeModal();
                            this.forceUpdate();
                        }}
                    />
                </div>
            ),
            type: MODAL_SIZE.SMALL,
        });
    };

    handleVerifyItems = () => {
        if (!this.isEditting) {
            this.isEditting = true;
        }
    };

    onChangeItemNameNew = (value) => {
        document.getElementById("required_msg").textContent = '';
        this.state.settingName = value;
    }

    setErrorMessage = (label, value) => {
        let id = "err_msg_" + label;
        document.getElementById(id).textContent = value;
    }

    onConfirmClaude35Add = async () => {
        const { commonStore: { formSettingStore, dataProcessingStore } } = this.props;
        const { t } = this.props;
        let names = formSettingStore.claude35Settings?.settingBody?.settings?.map(e => e.settingName);
        if (this.state.settingName == "") {
            document.getElementById("required_msg").textContent = t("validate.field_is_empty");
        } else if (names.includes(this.state.settingName)) {
            document.getElementById("required_msg").textContent = t("form_setting.claude35.save_as.error.already_in_use")
        } else {
            if (this.isValidClaude35SettingData()) {
                dataProcessingStore.addCurrentSetting(this.state.settingName, false, this.claude35AddCallback);
                this.isEditting = false;
                this.handleSelectTab(0);
            }
            else {
                this.closeModal();
                this.props.commonStore.formSettingStore.setClaude35ColumnSetting(this.props.commonStore.formSettingStore.claude35Setting);
            }
        }
    }

    claude35AddCallback = () => {
        const { commonStore: { formSettingStore, dataProcessingStore } } = this.props;
        let payload = formSettingStore.createClaude35AddPayload(this.state.settingName, dataProcessingStore.createdId);
        formSettingStore.addClaude35Setting(payload);
        this.closeModal();
        this.state.settingName = "";
    }

    openClaude35AddModal = () => {
        const { modalStore, t } = this.props;
        modalStore.show({
            id: MODAL_ID.CREATE_FORM_SETTING,
            isOpen: true,
            header: t('form_setting.claude35.add_modal_title'),
            onCancel: this.closeModal,
            children: (
                <div className="text-c">
                    <div key={"modal-body"} className="modal-body modal-add-item">
                        <div className="row">
                            <div className="col-sm-1" />
                            <div className="col-sm-4 font-bold">
                                <span className="color-red">*</span>
                                {t("setting_definition.required")}
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: "15px" }}>
                            <div className="col-sm-1" />
                            <div className="col-sm-4 font-bold">{t("form_setting.claude35.add_modal.setting_name")}</div>
                            <div className="col-sm-6" id="div_item_name">
                                <input name="item_name"
                                    type="text"
                                    maxLength={50}
                                    onChange={(value) => this.onChangeItemNameNew(value.target.value)}
                                />
                                <span className="color-red" id="required_msg"></span>
                            </div>
                        </div>
                    </div>

                    <ModalFooter key={"modal-footer"}
                        saveButtonText={t('user.create')}
                        onConfirm={() => this.onConfirmClaude35Add()}
                        saveButtonClass="btn-primary"
                    />
                </div>
            ),
            type: 'medium'
        });
    };

    onConfirmClaude35Update = async () => {
        const { modalStore, t } = this.props;
        if (this.isValidClaude35SettingData()) {
            modalStore.show({
                id: "confirm",
                isOpen: true,
                header: t("form_setting.update_model_title"),
                onCancel: () => this.closeModal(),
                children: (
                    <div className="text-c">
                        <div key={"modal-body"} className="modal-body">
                            <span>{t("form_setting.specifying_form_settings.change_information")}</span>
                        </div>
                        <ModalFooter key={"modal-footer"}
                            saveButtonText={t("form_setting.specifying_form_settings.save")}
                            onConfirm={this.onConfirmClaude35UpdateProcess}
                            cancelButtonText={t("form_setting.specifying_form_settings.cancel")}
                            onCancel={this.closeModal}
                        />
                    </div>
                ),
                type: "small"
            });
        } else {
            this.props.commonStore.formSettingStore.setClaude35ColumnSetting(this.props.commonStore.formSettingStore.claude35Setting);
        }
    };

    onConfirmClaude35UpdateProcess = async () => {
        const { commonStore: { dataProcessingStore, formSettingStore } } = this.props;
        this.closeModal();
        if (formSettingStore.claude35Setting.id == "-1") {
            this.claude35UpdateCallback();
        } else {
            if (formSettingStore.claude35Setting.dataProcessingId === null || formSettingStore.claude35Setting.dataProcessingId === undefined) {
                dataProcessingStore.addCurrentSetting(formSettingStore.claude35Setting.settingName, true, this.claude35UpdateCallback);
            } else {
                dataProcessingStore.updateCurrentSetting(this.claude35UpdateCallback);
            }
        }
    }

    claude35UpdateCallback = () => {
        const { commonStore: { formSettingStore, dataProcessingStore } } = this.props;
        let payload = formSettingStore.createClaude35UpdatePayload(dataProcessingStore.createdId);
        formSettingStore.updateClaude35Setting(payload);
        this.isEditting = false;
    }

    onConfirmClaude35Delete = () => {
        const { modalStore, t } = this.props;
        modalStore.show({
            id: MODAL_ID.REMOVE,
            isOpen: true,
            header: t('form_setting.remove_model_title'),
            onCancel: this.closeModal,
            children: (
                <div className="text-c">
                    <div key={"modal-body"} className="modal-body">
                        <span>{t('form_setting.remove_model_content')}</span>
                    </div>
                    <ModalFooter key={"modal-footer"}
                        saveButtonText={t('definition.remove')}
                        onConfirm={() => {
                            this.closeModal();
                            this.props.commonStore.dataProcessingStore.setId(null);
                            let payload = this.props.commonStore.formSettingStore.createClaude35DeletePayload();
                            this.props.commonStore.formSettingStore.deleteClaude35Setting(payload);
                            this.isEditting = false;
                            this.handleSelectTab(0);
                        }}
                        cancelButtonText={t('definition.cancel')}
                        onCancel={this.closeModal}
                        saveButtonClass="btn-primary"
                    />
                </div>
            ),
            type: 'small'
        });
    };

    onConfirmClaude35Export = async (force = false) => {
        const { commonStore: { formSettingStore } } = this.props;
        if (this.isEditting && !force) {
            // 保存していないデータがあれば確認ダイアログ表示
            this.openClaude35ExportWithoutSaveModal();
        }
        else {
            formSettingStore.exportClaude35Setting();
            this.isEditting = false;
        }
    };

    onConfirmClaude35Import = (force = false) => {
        if (this.isEditting && !force) {
            // 保存していないデータがあれば確認ダイアログ表示
            this.openClaude35ImportWithoutSaveModal();
        }
        else {
            // インポート処理の呼び出し
            this.claude35InputRef.current.click();
        }
    };

    onClaude35ImportFileChange = async (event) => {
        const { t } = this.props;
        // インポートファイルのアップロード
        if (!event?.target?.files || event?.target?.files.length <= 0) {
            return;
        }
        const file = event?.target?.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target?.result;
            try {
                const jsonData = JSON.parse(content);
                if (this.isValidClaude35IndividualSetting(jsonData?.setting)) {
                    this.onClaude35ImportJson(jsonData);
                } else {
                    ReactNotifications("error", t("form_setting.claude35.import.error.json_parse"), "");
                    this.clearImportFile();
                }
            } catch (error) {
                ReactNotifications("error", t("form_setting.claude35.import.error.json_parse"), "");
                this.clearImportFile();
            }
        }
        reader.readAsText(file);
    }

    onClaude35ImportJson = async (json, force = false) => {
        const { commonStore: { formSettingStore, dataProcessingStore } } = this.props;
        const name = json?.setting?.settingName;
        let setting = formSettingStore.claude35Settings?.settingBody?.settings.find(e => name == e.settingName);
        if (!force && setting) {
            this.openClaude35ImportOverwriteModal(json);
        } else {
            formSettingStore.importClaude35Setting(CONFIG_FILE_EDITION.PREBUILT, json, () => {
                dataProcessingStore.get(() => {
                    formSettingStore.getAll(() => {
                        let setting = formSettingStore.claude35Settings?.settingBody?.settings.find(e => name == e.settingName);
                        this.onChangeClaude35Setting(setting.id, true);
                        this.clearImportFile();
                    });
                })
            });
            this.isEditting = false;
        }
    }

    clearImportFile = () => {
        this.claude35InputRef.current.value = "";
    }

    openClaude35ExportWithoutSaveModal = () => {
        const { modalStore, t } = this.props;
        modalStore.show({
            id: MODAL_ID.CONFIRM,
            isOpen: true,
            header: t("edit.change_page_confirm_title"),
            onCancel: () => this.closeModal(MODAL_ID.CONFIRM),
            children: (
                <div className="text-c">
                    <div key={"modal-body"} className="modal-body">
                        <span>{t("form_setting.claude35.export.without_saving")}</span>
                    </div>
                    <ModalFooter
                        key={"modal-footer"}
                        saveButtonText={t("edit.change_page_yes")}
                        onConfirm={() => {
                            this.closeModal();
                            this.onConfirmClaude35Export(true);
                        }}
                        cancelButtonText={t("edit.change_page_no")}
                        onCancel={() => {
                            this.closeModal();
                            this.forceUpdate();
                        }}
                    />
                </div>
            ),
            type: MODAL_SIZE.SMALL,
        });
    };

    openClaude35ImportWithoutSaveModal = () => {
        const { modalStore, t } = this.props;
        modalStore.show({
            id: MODAL_ID.CONFIRM,
            isOpen: true,
            header: t("edit.change_page_confirm_title"),
            onCancel: () => this.closeModal(MODAL_ID.CONFIRM),
            children: (
                <div className="text-c">
                    <div key={"modal-body"} className="modal-body">
                        <span>{t("form_setting.claude35.import.without_saving")}</span>
                    </div>
                    <ModalFooter
                        key={"modal-footer"}
                        saveButtonText={t("edit.change_page_yes")}
                        onConfirm={() => {
                            this.closeModal();
                            this.onConfirmClaude35Import(true);
                        }}
                        cancelButtonText={t("edit.change_page_no")}
                        onCancel={() => {
                            this.closeModal();
                            this.forceUpdate();
                        }}
                    />
                </div>
            ),
            type: MODAL_SIZE.SMALL,
        });
    };

    openClaude35ImportOverwriteModal = (json) => {
        const { modalStore, t } = this.props;
        modalStore.show({
            id: MODAL_ID.CONFIRM,
            isOpen: true,
            header: t("edit.change_page_confirm_title"),
            onCancel: () => this.closeModal(MODAL_ID.CONFIRM),
            children: (
                <div className="text-c">
                    <div key={"modal-body"} className="modal-body">
                        <span>{t("form_setting.claude35.import.overwrite")}</span>
                    </div>
                    <ModalFooter
                        key={"modal-footer"}
                        saveButtonText={t("edit.change_page_yes")}
                        onConfirm={() => {
                            this.closeModal();
                            this.onClaude35ImportJson(json, true);
                        }}
                        cancelButtonText={t("edit.change_page_no")}
                        onCancel={() => {
                            this.closeModal();
                            this.forceUpdate();
                            this.clearImportFile();
                        }}
                    />
                </div>
            ),
            type: MODAL_SIZE.SMALL,
        });
    };

    resetGeneralSetting = () => {
        const { commonStore: { formSettingStore } } = this.props;
        formSettingStore.resetGeneralSetting(this.prevSetting);
        this.closeModal();
    }

    updateAIGeneralSettng = () => {
        if (this.isValidClaude35SettingData()) {
            this.onConfirmClaude35UpdateProcess()
        }
    }

    openGeneralSettingModal = () => {
        const { modalStore, t } = this.props;
        const { commonStore: { formSettingStore } } = this.props;
        this.prevSetting = JSON.parse(JSON.stringify(formSettingStore.claude35Settings?.settingBody));
        modalStore.show({
            id: MODAL_ID.UPDATE_AI_GENERAL_SETTING,
            isOpen: true,
            header: t('ai_setting.general_setting'),
            onCancel: this.resetGeneralSetting,
            children: (
                <div className="screen-ai-general-setting-modal">
                    <div className="box-body-content">
                        <input id="general-setting" type="hidden" />
                        <div className="row">
                            <div className="col-sm-12">
                                <input type="checkbox" name="AUTO_ROTATION"
                                    defaultChecked={formSettingStore.claude35Settings?.settingBody?.AUTO_ROTATION}
                                    onChange={this.onClaude35GeneralSettingChange}
                                />
                                <span className="align-left-10">{t("form_setting.claude35.auto_rotation")}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                {t("form_setting.claude35.page_specification")}
                                <i className="fa fa-info-circle i-content" data-toggle="tooltip" data-placement="right" title={t("form_setting.claude35.page_specification.tooltip")}></i>
                            </div>
                            <div className="col-sm-9">
                                <input
                                    className="inp-content width-50"
                                    name="PAGE_SPECIFICATION"
                                    type="text"
                                    defaultValue={formSettingStore.claude35Settings?.settingBody?.PAGE_SPECIFICATION}
                                    placeholder={t("form_setting.claude35.page_specification.placeholder")}
                                    onChange={this.onClaude35GeneralSettingChange}
                                />
                                <div id="err_msg_PAGE_SPECIFICATION" className="err-msg"></div>
                            </div>
                        </div>
                    </div>

                    <ModalFooter key={"modal-footer"}
                        saveButtonText={t('common.save')}
                        onConfirm={this.updateAIGeneralSettng}
                        saveButtonClass="btn-primary"
                    />
                </div>
            ),
            type: 'big'
        });
        window.$('[data-toggle="tooltip"]').tooltip('destroy');
        window.$('[data-toggle="tooltip"]').tooltip({
            container: '.screen-ai-general-setting-modal',
            trigger: 'hover'
        });
    };

    closeModal = () => {
        const { modalStore } = this.props;
        modalStore.hideAll();
        this.isSubmited = false;
        this.executeOnDidUpdate();
    };

    isValidClaude35SettingData = () => {
        const { t } = this.props;
        let result = true;
        const general = this.props.commonStore.formSettingStore.claude35Settings?.settingBody;
        const setting = this.props.commonStore.formSettingStore.claude35Setting;
        if (general?.PAGE_SPECIFICATION !== null && general?.PAGE_SPECIFICATION !== undefined && !this.validateClaude35TargetPages(general?.PAGE_SPECIFICATION)) {
            return false;
        }

        if (Validate.validateCsvDownloadFolderName(setting.CSV_DOWNLOAD_FOLDER_NAME, t) !== "") {
            return false;
        }
        if (Validate.validateCsvDownloadFileName(setting.CSV_DOWNLOAD_FILE_NAME, t) !== "") {
            return false;
        }
        if (Validate.validateDownloadFolderName(setting.DOWNLOAD_FOLDER_NAME, t) !== "") {
            return false;
        }
        if (Validate.validateDownloadFileName(setting.DOWNLOAD_FILE_NAME, t) !== "") {
            return false;
        }

        for (const column of setting.columns) {
            if ((this.isBlank(column.key) && !this.isBlank(column.pattern)) || (!this.isBlank(column.key) && this.isBlank(column.pattern))) {
                return false;
            }
        }

        return result;
    }

    isValidClaude35IndividualSetting = (setting) => {
        const { t } = this.props;
        if (setting === null || setting === undefined) {
            return false;
        }
        if (setting.settingName === null || setting.settingName === undefined || this.isBlank(setting.settingName)) {
            return false;
        }
        if (Validate.validateCsvDownloadFolderName(setting.CSV_DOWNLOAD_FOLDER_NAME, t) !== "") {
            return false;
        }
        if (Validate.validateCsvDownloadFileName(setting.CSV_DOWNLOAD_FILE_NAME, t) !== "") {
            return false;
        }
        if (Validate.validateDownloadFolderName(setting.DOWNLOAD_FOLDER_NAME, t) !== "") {
            return false;
        }
        if (Validate.validateDownloadFileName(setting.DOWNLOAD_FILE_NAME, t) !== "") {
            return false;
        }

        for (const column of setting.columns) {
            if ((this.isBlank(column.key) && !this.isBlank(column.pattern)) || (!this.isBlank(column.key) && this.isBlank(column.pattern))) {
                return false;
            }
        }
        return true;
    }

    isBlank = (value) => {
        if (typeof (value) === "string") {
            value = value.trim();
        }
        if (value === null || value === undefined || value === "") {
            return true;
        }
        return false;
    }

    isOutRange = (value, min, max) => {
        value = parseFloat(value);
        if (isNaN(value)) {
            return true;
        }
        if (value < min || value > max) {
            return true;
        }
        return false;
    }

    handleSelectTab = index => {
        this.setState({ selectedIndexTab: index });
    };

    onClaude35KeyInputChange = (event) => {
        let idx = event.target.name;
        let value = event.target.value;
        this.props.commonStore.formSettingStore.changeClaude35KeyColumn(idx, value);
    }

    onClaude35PatternInputChange = (event) => {
        let idx = event.target.name;
        let value = event.target.value;
        this.props.commonStore.formSettingStore.changeClaude35PatternColumn(idx, value);
    }

    onClaude35TypeSelectChange = (event) => {
        let idx = event.target.name;
        let value = event.target.value;
        this.props.commonStore.formSettingStore.changeClaude35TypeColumn(idx, value);
    }

    onClaude35PostJobSelectChange = (event) => {
        let idx = event.target.name;
        let value = event.target.value;
        this.props.commonStore.formSettingStore.changeClaude35PostJobColumn(idx, value);
    }

    onSwapClaude35Column = (idx1, idx2) => {
        this.executeOnDidUpdate();
        this.props.commonStore.formSettingStore.swapClaude35Column(idx1, idx2);
        this.isEditting = true;
    }

    onInsertClaude35Column = (idx) => {
        this.executeOnDidUpdate();
        this.props.commonStore.formSettingStore.insertClaude35Column(idx);
        this.isEditting = true;
    }

    onInsertTailClaude35Column = () => {
        this.props.commonStore.formSettingStore.insertTailClaude35Column();
        this.isEditting = true;
    }

    onDeleteClaude35Column = (idx) => {
        this.executeOnDidUpdate();
        this.props.commonStore.formSettingStore.deleteClaude35Column(idx);
        this.isEditting = true;
    }

    validateClaude35Key = (idx) => {
        let key = this.props.commonStore.formSettingStore.claude35Setting.columns[idx].key;
        let pattern = this.props.commonStore.formSettingStore.claude35Setting.columns[idx].pattern;
        return !(this.isBlank(key) && !this.isBlank(pattern));
    }

    validateClaude35Pattern = (idx) => {
        let key = this.props.commonStore.formSettingStore.claude35Setting.columns[idx].key;
        let pattern = this.props.commonStore.formSettingStore.claude35Setting.columns[idx].pattern;
        return !(!this.isBlank(key) && this.isBlank(pattern));
    }

    validateClaude35TargetPages = (text) => {
        if (this.isBlank(text)) {
            return true;
        }
        let regex = /^\s*([0-9]+|-\s*[0-9]+|[0-9]+\s*-|[0-9]+\s*-\s*[0-9]+)\s*(,\s*([0-9]+|-\s*[0-9]+|[0-9]+\s*-|[0-9]+\s*-\s*[0-9]+)\s*)*$/g;
        return text.match(regex) !== null;
    }

    claude35Columns = () => {
        const { t } = this.props;
        return [
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.INDEX,
                width: "5%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                Header: t("form_setting.claude35.item_name_setting.no"),
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.index + 1}
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.KEY,
                width: "28%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.item_name_setting.key"),
                Cell: ({ row }) => {
                    return (
                        <div>
                            <input
                                name={row.index}
                                className="claude35-input"
                                type="text"
                                defaultValue={row?.original?.key}
                                placeholder={t("form_setting.claude35.item_name_setting.key.placeholder")}
                                onChange={this.onClaude35KeyInputChange}
                                onBlur={() => { this.handleVerifyItems() }}
                            />
                            {!this.validateClaude35Key(row.index)
                                && <div className="err-msg">{t("form_setting.claude35.key_requied")}</div>
                            }
                            {!this.validateClaude35Pattern(row.index)
                                && <div className="err-msg">&nbsp;</div>
                            }
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.PATTERN,
                width: "28%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.item_name_setting.pattern"),
                Cell: ({ row }) => {
                    return (
                        <div>
                            <input
                                name={row.index}
                                className="claude35-input"
                                type="text"
                                defaultValue={row?.original?.pattern}
                                placeholder={t("form_setting.claude35.item_name_setting.pattern.placeholder")}
                                onChange={this.onClaude35PatternInputChange}
                                onBlur={() => { this.handleVerifyItems() }}
                            />
                            {!this.validateClaude35Key(row.index)
                                && <div className="err-msg">&nbsp;</div>
                            }
                            {!this.validateClaude35Pattern(row.index)
                                && <div className="err-msg">{t("form_setting.claude35.pattern_requied")}</div>
                            }
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.TYPE,
                width: "10%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.item_name_setting.type"),
                Cell: ({ row }) => {
                    return (
                        <div>
                            <select
                                name={row.index}
                                style={{ width: "100%", padding: "1px" }}
                                className="claude35-input"
                                defaultValue={row?.original?.type !== null && row?.original?.type !== undefined ? row?.original?.type : "-1"}
                                onChange={this.onClaude35TypeSelectChange}
                                onBlur={() => { this.handleVerifyItems() }}>
                                <option value="-1">{t("form_setting.claude35.item_name_setting.type.not_specified")}</option>
                                <option value="0">{t("form_setting.claude35.item_name_setting.type.header")}</option>
                                <option value="1">{t("form_setting.claude35.item_name_setting.type.detail1")}</option>
                                <option value="2">{t("form_setting.claude35.item_name_setting.type.detail2")}</option>
                                <option value="3">{t("form_setting.claude35.item_name_setting.type.detail3")}</option>
                            </select>
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.POSTJOB,
                width: "17%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.item_name_setting.post_processing"),
                Cell: ({ row }) => {
                    return (
                        <div>
                            <select
                                name={row.index}
                                style={{ width: "100%", padding: "1px" }}
                                className="claude35-input"
                                defaultValue={row?.original?.postJob ? row?.original?.postJob : ""}
                                onChange={this.onClaude35PostJobSelectChange}
                                onBlur={() => { this.handleVerifyItems() }}>
                                <option value="">{t("form_setting.not_specified")}</option>
                                {
                                    this.props.commonStore.postProcessingStore.postProcesses &&
                                    this.props.commonStore.postProcessingStore.postProcesses.length > 0 &&
                                    this.props.commonStore.postProcessingStore.postProcesses.map(e => {
                                        return <option key={e.setting_name} value={e.setting_name}>{e.setting_name}</option>
                                    })
                                }
                            </select>
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.SWAP,
                width: "80px",
                disableResizing: true,
                disableSortBy: true,
                className: "action-claude35",
                headerClassName: "header-middle-align",
                Cell: ({ row }) => {
                    return (
                        <div>
                            <i className="fas fa-chevron-circle-up fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: row.index <= 0 ? "not-allowed" : "pointer", marginLeft: "0px", marginRight: "5px", opacity: row.index <= 0 ? .65 : 1 }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.item_name_setting.swap_above")} onClick={() => this.onSwapClaude35Column(row.index, row.index - 1)}></i>
                            <i className="fas fa-chevron-circle-down fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: row.index + 1 >= this.props.commonStore?.formSettingStore?.claude35Setting?.columns?.length ? "not-allowed" : "pointer", margin: "0px", opacity: row.index + 1 >= this.props.commonStore?.formSettingStore?.claude35Setting?.columns?.length ? .65 : 1 }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.item_name_setting.swap_below")} onClick={() => this.onSwapClaude35Column(row.index, row.index + 1)}></i>
                        </div >
                    );
                },
            },
            {
                accessor: ACCESSOR_FORMSETTING_CLAUDE35.ACTION,
                width: "80px",
                disableResizing: true,
                disableSortBy: true,
                className: "action-claude35",
                headerClassName: "header-middle-align",
                Cell: ({ row }) => {
                    return (
                        <div>
                            <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer", marginLeft: "0px", marginRight: "5px" }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("edit.add_one_line_above")} onClick={() => this.onInsertClaude35Column(row.index)}></i>
                            <i className="fas fa-minus-circle fa-2x ar-tooltip" style={{ color: "#dd4b39", cursor: "pointer", margin: "0px" }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("edit.delete_line")} onClick={() => this.onDeleteClaude35Column(row.index)}></i>
                        </div >
                    );
                },
            },
        ];
    }

    onInsertTailDataProcessingColumn = () => {
        this.props.commonStore.dataProcessingStore.insertTailProcessLine();
        this.isEditting = true;
    }

    onInsertDataProcessingColumn = (idx) => {
        this.executeOnDidUpdate();
        this.props.commonStore.dataProcessingStore.insertProcessLine(idx);
        this.isEditting = true;
    }

    onDeleteDataProcessingColumn = (idx) => {
        this.executeOnDidUpdate();
        this.props.commonStore.dataProcessingStore.deleteProcessLine(idx);
        this.isEditting = true;
    }

    onSwapDataProcessingColumn = (idx1, idx2) => {
        this.executeOnDidUpdate();
        this.props.commonStore.dataProcessingStore.swapProcessLine(idx1, idx2);
        this.isEditting = true;
    }

    onDataProcessingTypeChange = (event) => {
        let value = parseInt(event.target.value);
        this.props.commonStore.dataProcessingStore.changeDataProcessingType(value);
    }

    onDataProcessingInputChange = (event) => {
        let key = event.target.name;
        let value = event.target.value;
        this.props.commonStore.dataProcessingStore.changeSettingBodyParam(key, value);
    }

    claude35DataProcessingColumns = () => {
        const { t } = this.props;
        return [
            {
                accessor: ACCESSOR_DATA_PROCESSING.INDEX,
                width: "12%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                Header: t("form_setting.claude35.data_processing.idx"),
                Cell: ({ row }) => {
                    return (
                        <div className="selectable" onClick={() => this.props.commonStore.dataProcessingStore.focusProcessLine(row.index)}>
                            {row.index + 1}
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING.TYPE,
                width: "15%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-center-align",
                Header: t("form_setting.claude35.data_processing.type"),
                Cell: ({ row }) => {
                    let text = "";
                    switch (row?.original?.process_type) {
                        case DATA_PROCESSING_TYPE.CONVERSION:
                            text = t("form_setting.claude35.data_processing.type.convert");
                            break;
                        case DATA_PROCESSING_TYPE.MOVE:
                            text = t("form_setting.claude35.data_processing.type.move");
                            break;
                        case DATA_PROCESSING_TYPE.COPY:
                            text = t("form_setting.claude35.data_processing.type.copy");
                            break;
                        case DATA_PROCESSING_TYPE.DELETE:
                            text = t("form_setting.claude35.data_processing.type.delete");
                            break;
                        default:
                            text = "";
                            break;
                    }
                    return (<div className="selectable color-theme" onClick={() => this.props.commonStore.dataProcessingStore.focusProcessLine(row.index)}>{text}</div>);
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING.COMMENT,
                width: "45%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.data_processing.comment"),
                Cell: ({ row }) => {
                    return (
                        <div className="selectable" onClick={() => this.props.commonStore.dataProcessingStore.focusProcessLine(row.index)}>
                            {row?.original?.comment ? row?.original?.comment : "　"}
                        </div>
                    );
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING.SORT,
                width: "70px",
                disableResizing: true,
                disableSortBy: true,
                headerClassName: "process-list-btn header-middle-align",
                className: "process-list-btn",
                Cell: ({ row }) => {
                    return (
                        <div>
                            <i className="fas fa-chevron-circle-up fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: row.index <= 0 ? "not-allowed" : "pointer", marginLeft: "0px", marginRight: "5px", opacity: row.index <= 0 ? .65 : 1 }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.data_processing.swap_above")} onClick={() => this.onSwapDataProcessingColumn(row.index, row.index - 1)}></i>
                            <i className="fas fa-chevron-circle-down fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: row.index + 1 >= this.props.commonStore?.dataProcessingStore?.settingBody?.length ? "not-allowed" : "pointer", margin: "0px", opacity: row.index + 1 >= this.props.commonStore?.dataProcessingStore?.settingBody?.length ? .65 : 1 }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.data_processing.swap_below")} onClick={() => this.onSwapDataProcessingColumn(row.index, row.index + 1)}></i>
                        </div >
                    );
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING.ACTION,
                width: "70px",
                disableResizing: true,
                disableSortBy: true,
                headerClassName: "process-list-btn header-middle-align",
                className: "process-list-btn",
                Cell: ({ row }) => {
                    return (
                        <div>
                            <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer", marginLeft: "0px", marginRight: "5px" }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.data_processing.add_one_line_above")} onClick={() => this.onInsertDataProcessingColumn(row.index)}></i>
                            <i className="fas fa-minus-circle fa-2x ar-tooltip" style={{ color: "#dd4b39", cursor: "pointer", margin: "0px" }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.data_processing.delete_line")} onClick={() => this.onDeleteDataProcessingColumn(row.index)}></i>
                        </div >
                    );
                },
            },
        ];
    }

    onInsertTailDataProcessingConditions = () => {
        this.props.commonStore.dataProcessingStore.insertTailCondition();
        this.isEditting = true;
    }

    onInsertDataProcessingConditions = (idx) => {
        this.executeOnDidUpdate();
        this.props.commonStore.dataProcessingStore.insertCondition(idx);
        this.isEditting = true;
    }

    onDeleteDataProcessingConditions = (idx) => {
        this.executeOnDidUpdate();
        this.props.commonStore.dataProcessingStore.deleteCondition(idx);
        this.isEditting = true;
    }

    onConditionTypeSelectChange = (event, idx) => {
        let key = event.target.name;
        let value = parseInt(event.target.value);
        this.props.commonStore.dataProcessingStore.changeConditionSelect(idx, key, value);
    }

    onConditionSelectChange = (event, idx) => {
        let key = event.target.name;
        let value = event.target.value;
        this.props.commonStore.dataProcessingStore.changeConditionSelect(idx, key, value);
    }

    onConditionInputChange = (event, idx) => {
        let key = event.target.name;
        let value = event.target.value;
        this.props.commonStore.dataProcessingStore.changeConditionInput(idx, key, value);
    }

    getConditionTypes = () => {
        const { t, commonStore: { dataProcessingStore: { currentProcess } } } = this.props;
        switch (currentProcess.process_type) {
            case DATA_PROCESSING_TYPE.CONVERSION:
                return [
                    { idx: 0, text: t("form_setting.claude35.data_processing.conditions.type.conversion.0") },
                    { idx: 1, text: t("form_setting.claude35.data_processing.conditions.type.conversion.1") },
                    { idx: 2, text: t("form_setting.claude35.data_processing.conditions.type.conversion.2") },
                ];
            case DATA_PROCESSING_TYPE.MOVE:
                return [
                    { idx: 0, text: t("form_setting.claude35.data_processing.conditions.type.move.0") },
                    { idx: 1, text: t("form_setting.claude35.data_processing.conditions.type.move.1") },
                    { idx: 2, text: t("form_setting.claude35.data_processing.conditions.type.move.2") },
                ];
            case DATA_PROCESSING_TYPE.COPY:
                return [
                    { idx: 0, text: t("form_setting.claude35.data_processing.conditions.type.copy.0") },
                    { idx: 1, text: t("form_setting.claude35.data_processing.conditions.type.copy.1") },
                    { idx: 2, text: t("form_setting.claude35.data_processing.conditions.type.copy.2") },
                ];
            case DATA_PROCESSING_TYPE.DELETE:
                return [
                    { idx: 0, text: t("form_setting.claude35.data_processing.conditions.type.delete.0") },
                    { idx: 1, text: t("form_setting.claude35.data_processing.conditions.type.delete.1") },
                    { idx: 2, text: t("form_setting.claude35.data_processing.conditions.type.delete.2") },
                ];
            default:
                return [
                    { idx: 0, text: t("form_setting.claude35.data_processing.conditions.type.conversion.0") },
                    { idx: 1, text: t("form_setting.claude35.data_processing.conditions.type.conversion.1") },
                    { idx: 2, text: t("form_setting.claude35.data_processing.conditions.type.conversion.2") },
                ];
        }
    }

    claude35DataProcessingConditions = () => {
        const { t, commonStore: { formSettingStore } } = this.props;
        return [
            {
                accessor: ACCESSOR_DATA_PROCESSING_CONDITIONS.TYPE,
                width: "30%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.data_processing.conditions.type"),
                Cell: ({ row }) => {
                    return (
                        <select className="slct-content data-processing-condition" name="condition_type"
                            value={row?.original?.condition_type}
                            onChange={(e) => { this.onConditionTypeSelectChange(e, row.index) }}
                            onBlur={() => { this.handleVerifyItems() }}>
                            {this.getConditionTypes().map(e => {
                                return <option key={e.idx} value={e.idx}>{e.text}</option>
                            })}
                        </select>
                    );
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING_CONDITIONS.KEY,
                width: "30%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.data_processing.conditions.key"),
                Cell: ({ row }) => {
                    return (
                        <select className="slct-content data-processing-condition" name="key_condition"
                            value={row?.original?.key_condition}
                            onChange={(e) => { this.onConditionSelectChange(e, row.index) }}
                            onBlur={() => { this.handleVerifyItems() }}>
                            <option key="" value=""></option>
                            {
                                formSettingStore.getClaude35ColumnDetailKeys()?.map((e) => {
                                    return <option key={e} value={e}>{e}</option>
                                })
                            }
                        </select>
                    );
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING_CONDITIONS.VALUE,
                width: "30%",
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "cell-left-align",
                Header: t("form_setting.claude35.data_processing.conditions.value"),
                Cell: ({ row }) => {
                    return (
                        <input
                            className="inp-content data-processing-condition"
                            name="value_condition"
                            defaultValue={row?.original?.value_condition}
                            placeholder={t("form_setting.claude35.data_processing.conditions.value.placeholder")}
                            onChange={(e) => { this.onConditionInputChange(e, row.index) }}
                            onBlur={() => { this.handleVerifyItems() }}
                        />
                    );
                },
            },
            {
                accessor: ACCESSOR_DATA_PROCESSING_CONDITIONS.ACTION,
                width: "70px",
                disableResizing: true,
                disableSortBy: true,
                headerClassName: "header-middle-align",
                className: "process-list-btn",
                Cell: ({ row }) => {
                    return (
                        <div>
                            <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer", marginLeft: "0px", marginRight: "5px" }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.data_processing.add_one_line_above")} onClick={() => this.onInsertDataProcessingConditions(row.index)}></i>
                            <i className="fas fa-minus-circle fa-2x ar-tooltip" style={{ color: "#dd4b39", cursor: "pointer", margin: "0px" }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={t("form_setting.claude35.data_processing.delete_line")} onClick={() => this.onDeleteDataProcessingConditions(row.index)}></i>
                        </div >
                    );
                },
            },
        ];
    }

    render() {
        const { t, commonStore: { formSettingStore, formSettingStore: { sortListFormSettings, formSetting }, dataProcessingStore, } } = this.props;
        let formSettingBody = formSetting.settingBody;
        let tableData = this.props.commonStore.formSettingStore.prebuiltTable;
        let lastUpdateTime = this.props.commonStore.formSettingStore.formSetting.updatedAt
            ? moment(this.props.commonStore.formSettingStore.formSetting.updatedAt).format(DATE_FORMAT.full_time)
            : NO_DATE;
        return (
            <div className="screen-ai-setting" >
                <ContainerBox headerTitle={t("ai_setting.page_title")}>
                    <div className="admin-header row">
                        <div className="col-sm-11">
                            <div className="row">
                                <div className="col-sm-3" style={{ textAlign: "left", fontWeight: "bold" }}>
                                    {t("ai_setting.general_setting.auto_rotation")}
                                </div>
                                <div className="col-sm-3" id="text_settingName">
                                    {formSettingStore.claude35Settings?.settingBody?.AUTO_ROTATION === true ?
                                        t("ai_setting.general_setting.auto_rotation.true") : t("ai_setting.general_setting.auto_rotation.false")
                                    }
                                </div>
                                <div className="col-sm-3" style={{ textAlign: "left", fontWeight: "bold" }}>
                                    {t("ai_setting.general_setting.page_specification")}
                                </div>
                                <div className="col-sm-3" id="text_classificationType">
                                    {formSettingStore.claude35Settings?.settingBody?.PAGE_SPECIFICATION}
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-1">
                            <div className="row">
                                <button
                                    className="btn btn-primary f-r mb-3 mr-3"
                                    type="button"
                                    onClick={this.openGeneralSettingModal}>
                                    {t("ai_setting.general_setting")}
                                </button>
                            </div>
                        </div>
                    </div>
                </ContainerBox>
                <ContainerBox type="basic" className="admin-sb-container">
                    <div className="box-body">
                        {/* Control */}
                        <div className="row">
                            <div className="col-sm-4" style={{ paddingRight: "0px" }}>
                                {t("form_setting.lbl.claude35_setting_name")}
                                <select id="slct-claude35_setting_name" className="slct-content" style={{ width: "55%", marginLeft: "5px" }}
                                    value={formSettingStore.claude35Setting.id}
                                    onChange={(e) => this.onChangeClaude35Setting(e.target?.value)}>
                                    <option value="-1">{t("form_setting.create_new")}</option>
                                    {
                                        (formSettingStore.claude35Settings?.settingBody?.settings &&
                                            formSettingStore.claude35Settings?.settingBody?.settings.length > 0) &&
                                        formSettingStore.claude35Settings?.settingBody?.settings?.map((e) => {
                                            return <option key={e.id} value={e.id}>{e.settingName}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-sm-8">
                                <button className="btn btn-primary btn-export"
                                    disabled={
                                        formSettingStore.claude35Setting.id === null ||
                                        formSettingStore.claude35Setting.id === undefined ||
                                        formSettingStore.claude35Setting.id == -1
                                    }
                                    onClick={() => this.onConfirmClaude35Export()}>{t("form_setting.btn.export")}
                                </button>
                                <button className="btn btn-primary btn-import"
                                    onClick={() => this.onConfirmClaude35Import()}>{t("form_setting.btn.import")}
                                </button>
                                <input
                                    className="hidden"
                                    ref={this.claude35InputRef}
                                    type="file"
                                    accept=".json"
                                    onChange={this.onClaude35ImportFileChange}
                                    hidden
                                />
                                <button className="btn btn-primary btn-save-as"
                                    onClick={() => this.openClaude35AddModal()}>{t("form_setting.btn.save_as")}
                                </button>
                                <button className="btn btn-primary btn-save"
                                    disabled={
                                        formSettingStore.claude35Setting.id === null ||
                                        formSettingStore.claude35Setting.id === undefined ||
                                        formSettingStore.claude35Setting.id == -1
                                    }
                                    onClick={() => this.onConfirmClaude35Update()}>{t("form_setting.btn.save")}
                                </button>
                                <button className="btn btn-danger btn-remove"
                                    disabled={
                                        formSettingStore.claude35Setting.id === null ||
                                        formSettingStore.claude35Setting.id === undefined ||
                                        formSettingStore.claude35Setting.id == -1
                                    }
                                    onClick={() => this.onConfirmClaude35Delete()}>{t("form_setting.btn.remove")}
                                </button>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="box-content-ai" style={{ marginTop: "20px" }}>
                            <Tabs selectedIndex={this.state.selectedIndexTab} onSelect={this.handleSelectTab}>
                                <TabList>
                                    <Tab><span className="color-red">*</span>{t("form_setting.lbl.claude35.item_name_setting")}</Tab>
                                    <Tab>{t("form_setting.lbl.claude35.individual_setting")}</Tab>
                                    <Tab>{t("form_setting.lbl.claude35.data_processing_setting")}</Tab>
                                </TabList>

                                {/* 項目名設定 */}
                                <TabPanel>
                                    <div className="box-body-content table-body">
                                        <Table
                                            tblCode={TABLE_CODE.CLAUDE35_SETTING}
                                            columns={this.claude35Columns()}
                                            data={formSettingStore.claude35Setting?.columns}
                                            t={t}
                                            disablePaging={true}
                                            disableSelectionPageSize={true}
                                            enableServerSidePaging={false}
                                            tableFooter={
                                                <tr>
                                                    <td colSpan={6}>
                                                        <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer" }}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title={t("edit.add_one_line")} onClick={() => this.onInsertTailClaude35Column()}>
                                                        </i>
                                                    </td>
                                                </tr>
                                            }
                                            className="tbl-header"
                                        />
                                        <div style={{ padding: "0px" }} className="col-sm-9">
                                            {t("form_setting.claude35.column_description.before_link")}
                                            <a target="_blank" rel="noopener noreferrer" href="https://manual.airead.ai/usersmanual/oncloud/7-%E5%B8%B3%E7%A5%A8%E8%A8%AD%E5%AE%9A%E7%AE%A1%E7%90%86%E7%94%BB%E9%9D%A2/#74:~:text=%E3%82%92%E8%A8%98%E8%BC%89%E3%81%99%E3%82%8B-,7.4.5.%C2%A0%E8%A8%AD%E5%AE%9A%E4%BE%8B,-%EF%BC%9C%E8%AA%AD%E5%8F%96%E7%B5%90%E6%9E%9C">
                                                {t("form_setting.claude35.column_description.link")}
                                            </a>
                                            {t("form_setting.claude35.column_description.after_link")}
                                        </div>
                                    </div>
                                </TabPanel>

                                {/* 個別設定 */}
                                <TabPanel>
                                    <div className="box-body-content">
                                        <input id="individual-setting" type="hidden" />
                                        {/*
                                        <div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <input type="checkbox" name="USING_AI_VERIFICATION"
                                                        checked={formSettingStore.claude35Setting?.USING_AI_VERIFICATION}
                                                        onChange={this.onClaude35SettingChange}
                                                        onBlur={() => { this.handleVerifyItems() }} />
                                                    <span className="align-left-10">{t("form_setting.claude35.using_ai_verification")}</span>
                                                    <i className="fa fa-info-circle i-content" data-toggle="tooltip" data-placement="right" title={t("form_setting.claude35.using_ai_verification.tooltip")}></i>
                                                    <span className="align-left-10 color-red">{t("form_setting.claude35.using_ai_verification.warning")}</span>
                                                </div>
                                            </div>
                                            {
                                                formSettingStore.claude35Setting?.USING_AI_VERIFICATION &&
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        {t("form_setting.claude35.verification_model")}
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <select
                                                            name="VERIFICATION_MODEL"
                                                            className="slct-content width-50"
                                                            value={formSettingStore.claude35Setting?.VERIFICATION_MODEL}
                                                            onChange={this.onClaude35SettingChange}
                                                            onBlur={() => { this.handleVerifyItems() }}
                                                        >
                                                            {
                                                                formSettingStore.aiModels?.map((model) => {
                                                                    return <option key={model.form_code} value={model.form_code}>{model.config_name}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                formSettingStore.claude35Setting?.USING_AI_VERIFICATION &&
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        {t("form_setting.claude35.verification_error_handling")}
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <select
                                                            name="VERIFICATION_ERROR_HANDLING"
                                                            className="slct-content width-50"
                                                            value={formSettingStore.claude35Setting?.VERIFICATION_ERROR_HANDLING}
                                                            onChange={this.onClaude35SettingChange}
                                                            onBlur={() => { this.handleVerifyItems() }}
                                                        >
                                                            <option key="0" value="0">{t("form_setting.claude35.verification_error_handling.default")}</option>
                                                            <option key="1" value="1">{t("form_setting.claude35.verification_error_handling.clear")}</option>
                                                            <option key="2" value="2">{t("form_setting.claude35.verification_error_handling.add_prefix")}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                formSettingStore.claude35Setting?.USING_AI_VERIFICATION &&
                                                formSettingStore.claude35Setting?.VERIFICATION_ERROR_HANDLING == "2" &&
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        {t("form_setting.claude35.verification_error_prefix")}
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <input
                                                            className="inp-content width-50"
                                                            name="VERIFICATION_ERROR_PREFIX"
                                                            type="text"
                                                            value={formSettingStore.claude35Setting?.VERIFICATION_ERROR_PREFIX}
                                                            placeholder={t("form_setting.claude35.verification_error_prefix.placeholder")}
                                                            onChange={this.onClaude35SettingChange}
                                                            onBlur={() => { this.handleVerifyItems() }}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        */}
                                        <div className="row">
                                            <div className="col-sm-3">
                                                {t("form_setting.claude35.sorting_keywords")}
                                                <i className="fa fa-info-circle i-content" data-toggle="tooltip" data-placement="right" title={t("form_setting.claude35.sorting_keywords.tooltip")}></i>
                                            </div>
                                            <div className="col-sm-9">
                                                <input
                                                    className="inp-content width-50"
                                                    name="SORTING_KEYWORDS"
                                                    type="text"
                                                    value={formSettingStore.claude35Setting?.SORTING_KEYWORDS}
                                                    placeholder={t("form_setting.claude35.sorting_keywords.placeholder")}
                                                    onChange={this.onClaude35SettingChange}
                                                    onBlur={() => { this.handleVerifyItems() }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                {t("form_setting.claude35.free_text_field")}
                                            </div>
                                            <div className="col-sm-9">
                                                <textarea style={formSettingStore.freeTextFieldStyle}
                                                    className="inp-content-large"
                                                    name="FREE_TEXT_FIELD"
                                                    type="text"
                                                    value={formSettingStore.claude35Setting?.FREE_TEXT_FIELD}
                                                    placeholder={t("form_setting.claude35.free_text_field.placeholder")}
                                                    onChange={this.onClaude35SettingChange}
                                                    onBlur={() => { this.handleVerifyItems() }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <input type="checkbox" name="MERGE_HEADER_AND_DETAIL"
                                                    checked={formSettingStore.claude35Setting?.MERGE_HEADER_AND_DETAIL}
                                                    onChange={this.onClaude35SettingChange}
                                                    onBlur={() => { this.handleVerifyItems() }} />
                                                <span className="align-left-10">{t("form_setting.claude35.merge_header_and_detail")}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    {t("definition.form_group.setting.csv_download")}
                                                </div>
                                                <div className="col-sm-9">
                                                    <select
                                                        name="CSV_DOWNLOAD_SETTING"
                                                        className="slct-content width-50"
                                                        value={formSettingStore.claude35Setting?.CSV_DOWNLOAD_SETTING}
                                                        onChange={this.onClaude35SettingChange}
                                                        onBlur={() => { this.handleVerifyItems() }}
                                                    >
                                                        <option value={CSV_DOWNLOAD_SETTING.GLOBAL}>{t("definition.form_group.setting.csv_download.global")}</option>
                                                        <option value={CSV_DOWNLOAD_SETTING.INDIVIDUAL}>{t("definition.form_group.setting.csv_download.individual")}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                formSettingStore.claude35Setting?.CSV_DOWNLOAD_SETTING == CSV_DOWNLOAD_SETTING.INDIVIDUAL &&
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        {" "}
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <div className="col-sm-6" style={{ padding: "0px" }}>
                                                            <div className="col-sm-3">
                                                                {t("definition.form_group.setting.csv_download.foldername")}
                                                            </div>
                                                            <div className="col-sm-9" style={{ padding: "0px" }}>
                                                                <input
                                                                    name="CSV_DOWNLOAD_FOLDER_NAME"
                                                                    className="inp-content width-100" type="text" maxLength="255"
                                                                    value={formSettingStore.claude35Setting?.CSV_DOWNLOAD_FOLDER_NAME}
                                                                    placeholder={t("form_setting.claude35.csv_download.foldername.placeholder")}
                                                                    disabled={formSettingStore.claude35Setting?.CSV_DOWNLOAD_SETTING != CSV_DOWNLOAD_SETTING.INDIVIDUAL}
                                                                    onChange={this.onClaude35SettingChange}
                                                                    onBlur={() => { this.handleVerifyItems() }}>
                                                                </input>
                                                                {Validate.validateCsvDownloadFolderName(formSettingStore.claude35Setting?.CSV_DOWNLOAD_FOLDER_NAME, t) !== ""
                                                                    && <div className="err-msg">{Validate.validateCsvDownloadFolderName(formSettingStore.claude35Setting?.CSV_DOWNLOAD_FOLDER_NAME, t)}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6" style={{ padding: "0px" }}>
                                                            <div className="col-sm-3">
                                                                {t("definition.form_group.setting.csv_download.filename")}
                                                            </div>
                                                            <div className="col-sm-9" style={{ padding: "0px" }}>
                                                                <input
                                                                    name="CSV_DOWNLOAD_FILE_NAME"
                                                                    className="inp-content width-100" type="text" maxLength="255"
                                                                    value={formSettingStore.claude35Setting?.CSV_DOWNLOAD_FILE_NAME}
                                                                    placeholder={t("form_setting.claude35.csv_download.filename.placeholder")}
                                                                    disabled={formSettingStore.claude35Setting?.CSV_DOWNLOAD_SETTING != CSV_DOWNLOAD_SETTING.INDIVIDUAL}
                                                                    onChange={this.onClaude35SettingChange}
                                                                    onBlur={() => { this.handleVerifyItems() }}>
                                                                </input>
                                                                {Validate.validateCsvDownloadFileName(formSettingStore.claude35Setting?.CSV_DOWNLOAD_FILE_NAME, t) !== ""
                                                                    && <div className="err-msg">{Validate.validateCsvDownloadFileName(formSettingStore.claude35Setting?.CSV_DOWNLOAD_FILE_NAME, t)}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div>

                                            <div className="row">
                                                <div className="col-sm-3">
                                                    {t("definition.form_group.setting.download")}
                                                </div>
                                                <div className="col-sm-9">
                                                    <select
                                                        name="DOCUMENT_DOWNLOAD_SETTING"
                                                        className="slct-content width-50"
                                                        value={formSettingStore.claude35Setting?.DOCUMENT_DOWNLOAD_SETTING}
                                                        onChange={this.onClaude35SettingChange}
                                                        onBlur={() => { this.handleVerifyItems() }}
                                                    >
                                                        <option value={DOCUMENT_DOWNLOAD_SETTING.GLOBAL}>{t("definition.form_group.setting.download.global")}</option>
                                                        <option value={DOCUMENT_DOWNLOAD_SETTING.INDIVIDUAL}>{t("definition.form_group.setting.download.individual")}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                formSettingStore.claude35Setting?.DOCUMENT_DOWNLOAD_SETTING == DOCUMENT_DOWNLOAD_SETTING.INDIVIDUAL &&
                                                <div className="row">
                                                    <div className="col-sm-3">
                                                        {" "}
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <div className="col-sm-6" style={{ padding: "0px" }}>
                                                            <div className="col-sm-3">
                                                                {t("definition.form_group.setting.download.foldername")}
                                                            </div>
                                                            <div className="col-sm-9" style={{ padding: "0px" }}>
                                                                <input
                                                                    name="DOWNLOAD_FOLDER_NAME"
                                                                    className="inp-content width-100" type="text" maxLength="255"
                                                                    value={formSettingStore.claude35Setting?.DOWNLOAD_FOLDER_NAME}
                                                                    placeholder={t("form_setting.claude35.download.foldername.placeholder")}
                                                                    disabled={formSettingStore.claude35Setting?.DOCUMENT_DOWNLOAD_SETTING != DOCUMENT_DOWNLOAD_SETTING.INDIVIDUAL}
                                                                    onChange={this.onClaude35SettingChange}
                                                                    onBlur={() => { this.handleVerifyItems() }}>
                                                                </input>
                                                                {Validate.validateDownloadFolderName(formSettingStore.claude35Setting?.DOWNLOAD_FOLDER_NAME, t) !== ""
                                                                    && <div className="err-msg">{Validate.validateDownloadFolderName(formSettingStore.claude35Setting?.DOWNLOAD_FOLDER_NAME, t)}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6" style={{ padding: "0px" }}>
                                                            <div className="col-sm-3">
                                                                {t("definition.form_group.setting.download.filename")}
                                                            </div>
                                                            <div className="col-sm-9" style={{ padding: "0px" }}>
                                                                <input
                                                                    name="DOWNLOAD_FILE_NAME"
                                                                    className="inp-content width-100" type="text" maxLength="255"
                                                                    value={formSettingStore.claude35Setting?.DOWNLOAD_FILE_NAME}
                                                                    placeholder={t("form_setting.claude35.download.filename.placeholder")}
                                                                    disabled={formSettingStore.claude35Setting?.DOCUMENT_DOWNLOAD_SETTING != DOCUMENT_DOWNLOAD_SETTING.INDIVIDUAL}
                                                                    onChange={this.onClaude35SettingChange}
                                                                    onBlur={() => { this.handleVerifyItems() }}>
                                                                </input>
                                                                {Validate.validateDownloadFileName(formSettingStore.claude35Setting?.DOWNLOAD_FILE_NAME, t) !== ""
                                                                    && <div className="err-msg">{Validate.validateDownloadFileName(formSettingStore.claude35Setting?.DOWNLOAD_FILE_NAME, t)}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </TabPanel>

                                {/* データ加工設定 */}
                                <TabPanel>
                                    <ResizablePanels displayDirection="row" width="100%" height="100%" overflow-y="auto" panelsSize={[40, 60]} sizeUnitMeasure="%" resizerColor="#ffffff" resizerSize="5px" >
                                        <div className="process-list" style={{ overflow: "hidden", height: "100%" }}>
                                            {/* データ加工設定一覧 */}
                                            <Table
                                                tblCode={TABLE_CODE.CLAUDE35_DATA_PROCESSING_SETTING}
                                                columns={this.claude35DataProcessingColumns()}
                                                data={dataProcessingStore.settingBody}
                                                t={t}
                                                disablePaging={true}
                                                disableSelectionPageSize={true}
                                                enableServerSidePaging={false}
                                                rowClass={(row) => {
                                                    return this.props.commonStore.dataProcessingStore.currentIndex === row.index ? "selected-item" : "";
                                                }}
                                                tableFooter={
                                                    <tr>
                                                        <td colSpan={5}>
                                                            <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer" }}
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title={t("form_setting.claude35.data_processing.add_one_line")} onClick={() => this.onInsertTailDataProcessingColumn()}>
                                                            </i>
                                                        </td>
                                                    </tr>
                                                }
                                                className="tbl-header"
                                            />
                                        </div>
                                        <div className="process-info" style={{ overflow: "auto", height: "100%" }}>
                                            {/* データ加工設定詳細 */}
                                            {
                                                /* 種別 */
                                                dataProcessingStore.settingBody.length > 0 &&
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        {t("form_setting.claude35.data_processing.type")}
                                                    </div>

                                                    <div className="col-sm-8">
                                                        <select className="slct-content width-50" name="process_type"
                                                            value={dataProcessingStore.currentProcess?.process_type}
                                                            onChange={this.onDataProcessingTypeChange}
                                                            onBlur={() => { this.handleVerifyItems() }}>
                                                            <option value={DATA_PROCESSING_TYPE.CONVERSION}>{t("form_setting.claude35.data_processing.type.convert")}</option>
                                                            <option value={DATA_PROCESSING_TYPE.MOVE}>{t("form_setting.claude35.data_processing.type.move")}</option>
                                                            <option value={DATA_PROCESSING_TYPE.COPY}>{t("form_setting.claude35.data_processing.type.copy")}</option>
                                                            <option value={DATA_PROCESSING_TYPE.DELETE}>{t("form_setting.claude35.data_processing.type.delete")}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                /* 変換 */
                                                dataProcessingStore.settingBody.length > 0 &&
                                                dataProcessingStore.currentProcessingType() == DATA_PROCESSING_TYPE.CONVERSION &&
                                                <div>
                                                    {/* 変換対象項目名 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.convert.target_name")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <select className="slct-content width-50" name="target_key"
                                                                value={dataProcessingStore.currentProcess?.target_key}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}>
                                                                <option key="" value=""></option>
                                                                {
                                                                    formSettingStore.getClaude35ColumnDetailKeys()?.map((e) => {
                                                                        return <option key={e} value={e}>{e}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {/* 変換前パターン文字列 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.convert.before_pattern")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <input
                                                                className="inp-content"
                                                                style={{ width: "100%" }}
                                                                name="before"
                                                                value={dataProcessingStore.currentProcess.before}
                                                                placeholder={t("form_setting.claude35.data_processing.convert.before_pattern.placeholder")}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* 変換後パターン文字列 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.convert.after_pattern")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <input
                                                                className="inp-content"
                                                                style={{ width: "100%" }}
                                                                name="after"
                                                                value={dataProcessingStore.currentProcess.after}
                                                                placeholder={t("form_setting.claude35.data_processing.convert.after_pattern.placeholder")}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* データ加工条件 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.conditions")}
                                                        </div>
                                                        <div className="col-sm-8"></div>
                                                    </div>
                                                    <Table
                                                        tblCode={TABLE_CODE.CLAUDE35_SETTING}
                                                        columns={this.claude35DataProcessingConditions()}
                                                        data={dataProcessingStore.currentProcess.conditions}
                                                        t={t}
                                                        disablePaging={true}
                                                        disableSelectionPageSize={true}
                                                        enableServerSidePaging={false}
                                                        tableFooter={
                                                            <tr>
                                                                <td colSpan={4}>
                                                                    <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer" }}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title={t("edit.add_one_line")} onClick={() => this.onInsertTailDataProcessingConditions()}>
                                                                    </i>
                                                                </td>
                                                            </tr>
                                                        }
                                                        className="tbl-header"
                                                    />
                                                </div>
                                            }
                                            {
                                                /* 移動 */
                                                dataProcessingStore.settingBody.length > 0 &&
                                                dataProcessingStore.currentProcessingType() == DATA_PROCESSING_TYPE.MOVE &&
                                                <div>
                                                    {/* 種別下のメッセージ */}
                                                    <div className="row">
                                                        <div className="col-sm-4"></div>
                                                        <div className="col-sm-8" style={{ paddingLeft: "20px", marginTop: "-5px" }}>
                                                            {t("form_setting.claude35.data_processing.type.move.message")}
                                                        </div>
                                                    </div>
                                                    {/* 移動元項目名 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.move.source_name")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <select className="slct-content width-50" name="source_key"
                                                                value={dataProcessingStore.currentProcess?.source_key}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}>
                                                                <option key="" value=""></option>
                                                                {
                                                                    formSettingStore.getClaude35ColumnDetailKeys()?.map((e) => {
                                                                        return <option key={e} value={e}>{e}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {/* 移動先項目名 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.move.target_name")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <select className="slct-content width-50" name="target_key"
                                                                value={dataProcessingStore.currentProcess?.target_key}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}>
                                                                <option key="" value=""></option>
                                                                {
                                                                    formSettingStore.getClaude35ColumnDetailKeys()?.map((e) => {
                                                                        return <option key={e} value={e}>{e}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {/* データ加工条件 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.conditions")}
                                                        </div>
                                                        <div className="col-sm-8"></div>
                                                    </div>
                                                    <Table
                                                        tblCode={TABLE_CODE.CLAUDE35_SETTING}
                                                        columns={this.claude35DataProcessingConditions()}
                                                        data={dataProcessingStore.currentProcess.conditions}
                                                        t={t}
                                                        disablePaging={true}
                                                        disableSelectionPageSize={true}
                                                        enableServerSidePaging={false}
                                                        tableFooter={
                                                            <tr>
                                                                <td colSpan={4}>
                                                                    <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer" }}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title={t("edit.add_one_line")} onClick={() => this.onInsertTailDataProcessingConditions()}>
                                                                    </i>
                                                                </td>
                                                            </tr>
                                                        }
                                                        className="tbl-header"
                                                    />
                                                </div>
                                            }
                                            {
                                                /* コピー */
                                                dataProcessingStore.settingBody.length > 0 &&
                                                dataProcessingStore.currentProcessingType() == DATA_PROCESSING_TYPE.COPY &&
                                                <div>
                                                    {/* 種別下のメッセージ */}
                                                    <div className="row">
                                                        <div className="col-sm-4"></div>
                                                        <div className="col-sm-8" style={{ paddingLeft: "20px", marginTop: "-5px" }}>
                                                            {t("form_setting.claude35.data_processing.type.copy.message")}
                                                        </div>
                                                    </div>
                                                    {/* コピー元項目名 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.copy.source_name")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <select className="slct-content width-50" name="source_key"
                                                                value={dataProcessingStore.currentProcess?.source_key}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}>
                                                                <option key="" value=""></option>
                                                                {
                                                                    formSettingStore.getClaude35ColumnDetailKeys()?.map((e) => {
                                                                        return <option key={e} value={e}>{e}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {/* コピー先項目名 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.copy.target_name")}
                                                        </div>

                                                        <div className="col-sm-8">
                                                            <select className="slct-content width-50" name="target_key"
                                                                value={dataProcessingStore.currentProcess?.target_key}
                                                                onChange={this.onDataProcessingInputChange}
                                                                onBlur={() => { this.handleVerifyItems() }}>
                                                                <option key="" value=""></option>
                                                                {
                                                                    formSettingStore.getClaude35ColumnDetailKeys()?.map((e) => {
                                                                        return <option key={e} value={e}>{e}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {/* データ加工条件 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.conditions")}
                                                        </div>
                                                        <div className="col-sm-8"></div>
                                                    </div>
                                                    <Table
                                                        tblCode={TABLE_CODE.CLAUDE35_SETTING}
                                                        columns={this.claude35DataProcessingConditions()}
                                                        data={dataProcessingStore.currentProcess.conditions}
                                                        t={t}
                                                        disablePaging={true}
                                                        disableSelectionPageSize={true}
                                                        enableServerSidePaging={false}
                                                        tableFooter={
                                                            <tr>
                                                                <td colSpan={4}>
                                                                    <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer" }}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title={t("edit.add_one_line")} onClick={() => this.onInsertTailDataProcessingConditions()}>
                                                                    </i>
                                                                </td>
                                                            </tr>
                                                        }
                                                        className="tbl-header"
                                                    />
                                                </div>
                                            }
                                            {
                                                /* 削除 */
                                                dataProcessingStore.settingBody.length > 0 &&
                                                dataProcessingStore.currentProcessingType() == DATA_PROCESSING_TYPE.DELETE &&
                                                <div>
                                                    {/* データ加工条件 */}
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            {t("form_setting.claude35.data_processing.conditions")}
                                                        </div>
                                                        <div className="col-sm-8"></div>
                                                    </div>
                                                    <Table
                                                        tblCode={TABLE_CODE.CLAUDE35_SETTING}
                                                        columns={this.claude35DataProcessingConditions()}
                                                        data={dataProcessingStore.currentProcess.conditions}
                                                        t={t}
                                                        disablePaging={true}
                                                        disableSelectionPageSize={true}
                                                        enableServerSidePaging={false}
                                                        tableFooter={
                                                            <tr>
                                                                <td colSpan={4}>
                                                                    <i className="fas fa-plus-circle fa-2x ar-tooltip" style={{ color: "#377fa8", cursor: "pointer" }}
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title={t("edit.add_one_line")} onClick={() => this.onInsertTailDataProcessingConditions()}>
                                                                    </i>
                                                                </td>
                                                            </tr>
                                                        }
                                                        className="tbl-header"
                                                    />
                                                </div>
                                            }
                                            {
                                                /* コメント */
                                                dataProcessingStore.settingBody.length > 0 &&
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        {t("form_setting.claude35.data_processing.comment")}
                                                    </div>

                                                    <div className="col-sm-8">
                                                        <input
                                                            className="inp-content"
                                                            style={{ width: "100%" }}
                                                            name="comment"
                                                            value={dataProcessingStore.currentProcess.comment}
                                                            placeholder={t("form_setting.claude35.data_processing.comment.placeholder")}
                                                            onChange={this.onDataProcessingInputChange}
                                                            onBlur={() => { this.handleVerifyItems() }}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </ResizablePanels>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </ContainerBox >
            </div >
        )
    }
}

export default withRouter(withTranslation()(ScreenAISetting));